import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';


@Component({
  selector: 'app-testarea',
  templateUrl: './testarea.component.html',
  styleUrls: ['./operation.component.css']
})
export class TestareaComponent implements OnInit {

  constructor(
    public partnerService: ApiPartnerService
  ) { }

  ngOnInit() {
  }

  looppgw(){
    //alert('oke');
    let data = {"trx_id":3042828,"customer_id":2100016095,"reff_id":"192118ISxxxxx","customer_type":1,"amount":100000,"paid":100000,"paiddate":"2021-10-21 05:00:00","is_valid":1,"note":"Prepaid"};
    for (let i = 0; i < 10; i++) {
      this.partnerService.PostPayment(data).subscribe((output: any) => {
          console.log(output.data);
    
        });
    console.log(i);
    }
    return;
  }

}
